import React from 'react'
import styled from 'styled-components'

export const Badge = ({ children, hexColor }: { children: React.ReactNode; hexColor?: string }) => {
  return <BadgeContainer hexColor={hexColor}>{children}</BadgeContainer>
}

const BadgeContainer = styled.div<{
  hexColor?: string
}>`
  background-color: ${({ hexColor, theme }) => (hexColor ? hexColor + '10' : theme.tableRowBorder)};
  border: 1px solid ${({ hexColor, theme }) => hexColor || theme.tableRowBorder};
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
  color: ${({ hexColor, theme }) => hexColor || theme.textFaded};
  font-weight: 500;
  height: fit-content;
  display: flex;
  align-items: center;
  gap: 4px;
  width: fit-content;

  svg {
    width: 12px;
    height: 12px;
  }
`
